import { useTranslation } from 'react-i18next';
import JsonLd from '@/components/feature/JsonLd';
import { SITE_URL, LOGO_URL } from '@/components/feature/seo';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import TopicsGuidesSection from './components/TopicsGuidesSection';
import PillarSection from './components/PillarSection';
import SafetyFaqSection from './components/SafetyFaqSection';

export default function Home() {
  const { t } = useTranslation();

  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: t('common.brand'),
    url: SITE_URL,
    description: t('home.metaDescription'),
    inLanguage: ['en', 'pl', 'es', 'fr'],
  };

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: t('common.brand'),
    url: SITE_URL,
    logo: LOGO_URL,
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: t('home.faq.q1'), acceptedAnswer: { '@type': 'Answer', text: t('home.faq.a1') } },
      { '@type': 'Question', name: t('home.faq.q2'), acceptedAnswer: { '@type': 'Answer', text: t('home.faq.a2') } },
      { '@type': 'Question', name: t('home.faq.q3'), acceptedAnswer: { '@type': 'Answer', text: t('home.faq.a3') } },
      { '@type': 'Question', name: t('home.faq.q4'), acceptedAnswer: { '@type': 'Answer', text: t('home.faq.a4') } },
      { '@type': 'Question', name: t('home.faq.q5'), acceptedAnswer: { '@type': 'Answer', text: t('home.faq.a5') } },
      { '@type': 'Question', name: t('home.faq.q6'), acceptedAnswer: { '@type': 'Answer', text: t('home.faq.a6') } },
    ],
  };

  return (
    <>
      <JsonLd data={websiteLd} />
      <JsonLd data={organizationLd} />
      <JsonLd data={faqLd} />
      <div className="flex min-h-screen flex-col bg-background-50">
        <Header />
        <main className="flex-1">
          <Hero />
          <CategorySection />
          <TopicsGuidesSection />
          <PillarSection />
          <SafetyFaqSection />
        </main>
        <Footer />
      </div>
    </>
  );
}